"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrgConfigDTO = exports.OrgConfigDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.OrgConfigDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    defaultProperties: [],
    definitions: {
        FileMediaDTO: {
            defaultProperties: [],
            properties: {
                comment: {
                    title: "comment",
                    type: "string",
                },
                description: {
                    title: "description",
                    type: "string",
                },
                downloadUrl: {
                    title: "downloadUrl",
                    type: "string",
                },
                extension: {
                    title: "extension",
                    type: "string",
                },
                fullPath: {
                    title: "fullPath",
                    type: "string",
                },
                md5: {
                    title: "md5",
                    type: "string",
                },
                size: {
                    title: "size",
                    type: ["string", "number"],
                },
                storageBucket: {
                    title: "storageBucket",
                    type: "string",
                },
                storageLocation: {
                    title: "storageLocation",
                    type: "string",
                },
                storageProvider: {
                    title: "storageProvider",
                    type: "string",
                },
                storageType: {
                    title: "storageType",
                    type: "string",
                },
                title: {
                    title: "title",
                    type: "string",
                },
                type: {
                    title: "type",
                    type: "string",
                },
            },
            propertyOrder: [
                "extension",
                "type",
                "fullPath",
                "size",
                "storageProvider",
                "storageType",
                "storageBucket",
                "storageLocation",
                "downloadUrl",
                "comment",
                "title",
                "description",
                "md5",
            ],
            required: ["extension", "fullPath", "size"],
            title: "FileMediaDTO",
            type: "object",
        },
        OrgConfigCustomDataSchemasDTO: {
            defaultProperties: [],
            properties: {
                jsonSchema: {
                    $ref: "#/definitions/RjsfJsonSchemaDTO",
                    title: "jsonSchema",
                },
                uiSchema: {
                    $ref: "#/definitions/RjsfUiSchemaDTO",
                    title: "uiSchema",
                },
            },
            propertyOrder: ["jsonSchema", "uiSchema"],
            required: ["jsonSchema", "uiSchema"],
            title: "OrgConfigCustomDataSchemasDTO",
            type: "object",
        },
        OrgConfigCustomLogoDTO: {
            defaultProperties: [],
            properties: {
                desktop: {
                    $ref: "#/definitions/FileMediaDTO",
                    title: "desktop",
                },
                mobile: {
                    $ref: "#/definitions/FileMediaDTO",
                    title: "mobile",
                },
            },
            propertyOrder: ["mobile", "desktop"],
            required: ["desktop", "mobile"],
            title: "OrgConfigCustomLogoDTO",
            type: "object",
        },
        OrgConfigServicesDTO: {
            additionalProperties: {
                defaultProperties: [],
                properties: {
                    serviceId: {
                        title: "serviceId",
                        type: "string",
                    },
                    version: {
                        title: "version",
                        type: "number",
                    },
                },
                propertyOrder: ["serviceId", "version"],
                required: ["serviceId", "version"],
                type: "object",
            },
            defaultProperties: [],
            propertyOrder: [],
            title: "OrgConfigServicesDTO",
            type: "object",
        },
        PortalUIPermissionsDTO: {
            defaultProperties: [],
            properties: {
                akularStoreFab: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "akularStoreFab",
                },
                forgeUploader: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "forgeUploader",
                },
                masterAdmin: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "masterAdmin",
                },
                menuGraphic: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "menuGraphic",
                },
                menuLeadGraphic: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "menuLeadGraphic",
                },
                menuOrgAdmin: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "menuOrgAdmin",
                },
                menuPublic: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "menuPublic",
                },
                menuStandard: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "menuStandard",
                },
                orgAdminOrgDetails: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "orgAdminOrgDetails",
                },
                orgAdminUnits: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "orgAdminUnits",
                },
                orgAdminUsers: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "orgAdminUsers",
                },
                orgOwner: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "orgOwner",
                },
                urlAccountBilling: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlAccountBilling",
                },
                urlAccountMessages: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlAccountMessages",
                },
                urlAccountProposals: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlAccountProposals",
                },
                urlAdmin: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlAdmin",
                },
                urlBackendTest: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlBackendTest",
                },
                urlCompanySettings: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlCompanySettings",
                },
                urlInfoCookies: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlInfoCookies",
                },
                urlInfoData: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlInfoData",
                },
                urlInfoImprint: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlInfoImprint",
                },
                urlInfoTerms: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlInfoTerms",
                },
                urlLogin: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlLogin",
                },
                urlModel: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlModel",
                },
                urlOrgAdmin: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlOrgAdmin",
                },
                urlQueue: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlQueue",
                },
                urlResetPassword: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlResetPassword",
                },
                urlSalesOfferings: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlSalesOfferings",
                },
                urlSignup: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlSignup",
                },
                urlSupportTicket: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlSupportTicket",
                },
                urlTask: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlTask",
                },
                urlTutorials: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlTutorials",
                },
                urlUpload: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlUpload",
                },
                urlUser: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlUser",
                },
                urlUserDashboard: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlUserDashboard",
                },
                urlUserModels: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "urlUserModels",
                },
                userAddOnlyInvite: {
                    $ref: "#/definitions/{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
                    title: "userAddOnlyInvite",
                },
            },
            propertyOrder: [
                "urlUser",
                "urlAccountBilling",
                "urlAccountProposals",
                "urlInfoImprint",
                "urlInfoTerms",
                "urlInfoCookies",
                "urlInfoData",
                "urlAccountMessages",
                "urlCompanySettings",
                "urlSignup",
                "urlTask",
                "urlLogin",
                "urlAdmin",
                "urlOrgAdmin",
                "urlBackendTest",
                "urlQueue",
                "urlModel",
                "urlUpload",
                "urlUserModels",
                "urlSupportTicket",
                "urlTutorials",
                "urlSalesOfferings",
                "urlResetPassword",
                "urlUserDashboard",
                "menuPublic",
                "menuStandard",
                "menuOrgAdmin",
                "menuGraphic",
                "menuLeadGraphic",
                "orgOwner",
                "masterAdmin",
                "forgeUploader",
                "userAddOnlyInvite",
                "akularStoreFab",
                "orgAdminUnits",
                "orgAdminUsers",
                "orgAdminOrgDetails",
            ],
            title: "PortalUIPermissionsDTO",
            type: "object",
        },
        RemovedDTO: {
            defaultProperties: [],
            properties: {
                appType: {
                    $ref: "#/definitions/appType",
                    title: "appType",
                },
                comment: {
                    title: "comment",
                    type: "string",
                },
                removedAt: {
                    title: "removedAt",
                    type: "number",
                },
                removedBy: {
                    title: "removedBy",
                    type: "string",
                },
            },
            propertyOrder: ["removedBy", "removedAt", "appType", "comment"],
            required: ["removedAt", "removedBy"],
            title: "RemovedDTO",
            type: "object",
        },
        RjsfJsonSchemaDTO: {
            defaultProperties: [],
            properties: {
                $id: {
                    title: "$id",
                    type: "string",
                },
                $schema: {
                    title: "$schema",
                    type: "string",
                },
                additionalItems: {
                    $ref: "#/definitions/RjsfJsonSchemaDTO",
                    title: "additionalItems",
                },
                additionalProperties: {
                    defaultProperties: [],
                    properties: {
                        type: {
                            title: "type",
                            type: "string",
                        },
                    },
                    propertyOrder: ["type"],
                    required: ["type"],
                    title: "additionalProperties",
                    type: "object",
                },
                componentConfig: {
                    title: "componentConfig",
                },
                default: {
                    title: "default",
                    type: "string",
                },
                defaultProperties: {
                    items: {},
                    title: "defaultProperties",
                    type: "array",
                },
                definitions: {
                    title: "definitions",
                },
                description: {
                    title: "description",
                    type: "string",
                },
                format: {
                    $ref: "#/definitions/customDataFormat",
                    title: "format",
                },
                items: {
                    items: {
                        $ref: "#/definitions/RjsfJsonSchemaDTO",
                    },
                    title: "items",
                    type: "array",
                },
                lang: {
                    additionalProperties: {
                        defaultProperties: [],
                        properties: {
                            description: {
                                title: "description",
                                type: "string",
                            },
                            help: {
                                title: "help",
                                type: "string",
                            },
                            title: {
                                title: "title",
                                type: "string",
                            },
                        },
                        propertyOrder: ["title", "help", "description"],
                        required: ["title"],
                        type: "object",
                    },
                    defaultProperties: [],
                    propertyOrder: [],
                    title: "lang",
                    type: "object",
                },
                minItems: {
                    title: "minItems",
                    type: "number",
                },
                pattern: {
                    title: "pattern",
                    type: "string",
                },
                properties: {
                    title: "properties",
                },
                required: {
                    items: {
                        type: "string",
                    },
                    title: "required",
                    type: "array",
                },
                title: {
                    title: "title",
                    type: "string",
                },
                translatable: {
                    title: "translatable",
                    type: "boolean",
                },
                type: {
                    $ref: "#/definitions/customDataType",
                    title: "type",
                },
                validator: {
                    title: "validator",
                    type: "string",
                },
            },
            propertyOrder: [
                "$schema",
                "$id",
                "title",
                "description",
                "defaultProperties",
                "definitions",
                "properties",
                "minItems",
                "items",
                "additionalItems",
                "required",
                "type",
                "pattern",
                "componentConfig",
                "validator",
                "lang",
                "translatable",
                "format",
                "additionalProperties",
                "default",
            ],
            required: ["$id", "$schema", "lang", "type"],
            title: "RjsfJsonSchemaDTO",
            type: "object",
        },
        RjsfUiSchemaDTO: {
            additionalProperties: {},
            defaultProperties: [],
            properties: {
                "ui:options": {
                    defaultProperties: [],
                    properties: {
                        order: {
                            items: {
                                type: "string",
                            },
                            title: "order",
                            type: "array",
                        },
                        rootFieldId: {
                            title: "rootFieldId",
                            type: "string",
                        },
                    },
                    propertyOrder: ["order", "rootFieldId"],
                    title: "ui:options",
                    type: "object",
                },
            },
            propertyOrder: ["ui:options"],
            required: ["ui:options"],
            title: "RjsfUiSchemaDTO",
            type: "object",
        },
        SetupItemDTO: {
            defaultProperties: [],
            properties: {
                key: {
                    title: "key",
                    type: "string",
                },
                tracker: {
                    $ref: "#/definitions/TrackerDTO",
                    title: "tracker",
                },
                value: {
                    title: "value",
                },
            },
            propertyOrder: ["key", "value", "tracker"],
            required: ["key", "value"],
            title: "SetupItemDTO",
            type: "object",
        },
        TrackerDTO: {
            defaultProperties: [],
            properties: {
                comment: {
                    title: "comment",
                },
                createdApp: {
                    $ref: "#/definitions/appType",
                    title: "createdApp",
                },
                createdAt: {
                    title: "createdAt",
                    type: "number",
                },
                createdBy: {
                    title: "createdBy",
                    type: "string",
                },
                key: {
                    title: "key",
                    type: "string",
                },
                previousValue: {
                    title: "previousValue",
                },
                updatedApp: {
                    $ref: "#/definitions/appType",
                    title: "updatedApp",
                },
                updatedAt: {
                    title: "updatedAt",
                    type: "number",
                },
                updatedBy: {
                    title: "updatedBy",
                    type: "string",
                },
            },
            propertyOrder: [
                "createdAt",
                "updatedAt",
                "createdBy",
                "updatedBy",
                "createdApp",
                "updatedApp",
                "previousValue",
                "comment",
                "key",
            ],
            required: ["createdApp", "createdAt", "createdBy", "updatedApp", "updatedAt", "updatedBy"],
            title: "TrackerDTO",
            type: "object",
        },
        appType: {
            enum: ["A", "GA", "I", "M", "SC", "SE", "T", "U", "W"],
            title: "appType",
            type: "string",
        },
        customDataFormat: {
            enum: ["data-url", "date", "date-time", "file"],
            title: "customDataFormat",
            type: "string",
        },
        customDataType: {
            enum: ["array", "boolean", "null", "number", "object", "string"],
            title: "customDataType",
            type: "string",
        },
        dataProviderType: {
            enum: ["firebaseRdb", "firestore"],
            title: "dataProviderType",
            type: "string",
        },
        templateIdConfig: {
            defaultProperties: [],
            properties: {
                INVITE: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "INVITE",
                    type: "number",
                },
                MODEL_SHARE_EXISTING_USER: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "MODEL_SHARE_EXISTING_USER",
                    type: "number",
                },
                MODEL_SHARE_NEW_USER: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "MODEL_SHARE_NEW_USER",
                    type: "number",
                },
                ORG_CREATE_USER: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "ORG_CREATE_USER",
                    type: "number",
                },
                ORG_INVITE: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "ORG_INVITE",
                    type: "number",
                },
                SEND_SIGN_IN_LINK: {
                    enum: [20, 22, 24, 25, 29, 9],
                    title: "SEND_SIGN_IN_LINK",
                    type: "number",
                },
            },
            propertyOrder: [
                "INVITE",
                "ORG_INVITE",
                "ORG_CREATE_USER",
                "MODEL_SHARE_EXISTING_USER",
                "MODEL_SHARE_NEW_USER",
                "SEND_SIGN_IN_LINK",
            ],
            title: "templateIdConfig",
            type: "object",
        },
        "{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}": {
            defaultProperties: [],
            properties: {
                A: {
                    title: "A",
                    type: "boolean",
                },
                C: {
                    title: "C",
                    type: "boolean",
                },
                D: {
                    title: "D",
                    type: "boolean",
                },
                M: {
                    title: "M",
                    type: "boolean",
                },
                R: {
                    title: "R",
                    type: "boolean",
                },
                RA: {
                    title: "RA",
                    type: "boolean",
                },
                RO: {
                    title: "RO",
                    type: "boolean",
                },
                S: {
                    title: "S",
                    type: "boolean",
                },
                W: {
                    title: "W",
                    type: "boolean",
                },
                WA: {
                    title: "WA",
                    type: "boolean",
                },
                WO: {
                    title: "WO",
                    type: "boolean",
                },
            },
            propertyOrder: ["W", "M", "A", "R", "RO", "WO", "RA", "WA", "D", "C", "S"],
            title: "{W?:boolean;M?:boolean;A?:boolean;R?:boolean;RO?:boolean;WO?:boolean;RA?:boolean;WA?:boolean;D?:boolean;C?:boolean;S?:boolean;}",
            type: "object",
        },
    },
    properties: {
        allowedPaths: {
            items: {
                type: "string",
            },
            title: "allowedPaths",
            type: "array",
        },
        appTheme: {
            title: "appTheme",
        },
        createUserPassOverride: {
            title: "createUserPassOverride",
            type: "string",
        },
        customAttributes: {
            additionalProperties: {
                $ref: "#/definitions/SetupItemDTO",
            },
            defaultProperties: [],
            propertyOrder: [],
            title: "customAttributes",
            type: "object",
        },
        customDataSchemas: {
            defaultProperties: [],
            properties: {
                modelVersion: {
                    $ref: "#/definitions/OrgConfigCustomDataSchemasDTO",
                    title: "modelVersion",
                },
                org: {
                    $ref: "#/definitions/OrgConfigCustomDataSchemasDTO",
                    title: "org",
                },
                project: {
                    $ref: "#/definitions/OrgConfigCustomDataSchemasDTO",
                    title: "project",
                },
                unit: {
                    $ref: "#/definitions/OrgConfigCustomDataSchemasDTO",
                    title: "unit",
                },
                user: {
                    $ref: "#/definitions/OrgConfigCustomDataSchemasDTO",
                    title: "user",
                },
            },
            propertyOrder: ["org", "user", "project", "modelVersion", "unit"],
            title: "customDataSchemas",
            type: "object",
        },
        customLogo: {
            $ref: "#/definitions/OrgConfigCustomLogoDTO",
            title: "customLogo",
        },
        disableShareEmail: {
            title: "disableShareEmail",
            type: "boolean",
        },
        externalData: {
            additionalProperties: {
                defaultProperties: [],
                properties: {
                    id: {
                        title: "id",
                        type: "string",
                    },
                    providerType: {
                        $ref: "#/definitions/dataProviderType",
                        title: "providerType",
                    },
                    schema: {
                        $ref: "#/definitions/RjsfJsonSchemaDTO",
                        title: "schema",
                    },
                },
                propertyOrder: ["id", "schema", "providerType"],
                required: ["id", "providerType", "schema"],
                type: "object",
            },
            defaultProperties: [],
            propertyOrder: [],
            title: "externalData",
            type: "object",
        },
        portalUiPermissions: {
            $ref: "#/definitions/PortalUIPermissionsDTO",
            title: "portalUiPermissions",
        },
        redirects: {
            defaultProperties: [],
            properties: {
                base: {
                    title: "base",
                    type: "string",
                },
                createPassword: {
                    title: "createPassword",
                    type: "string",
                },
            },
            propertyOrder: ["createPassword", "base"],
            title: "redirects",
            type: "object",
        },
        removed: {
            $ref: "#/definitions/RemovedDTO",
            title: "removed",
        },
        sendInBlueTemplateOverrides: {
            $ref: "#/definitions/templateIdConfig",
            title: "sendInBlueTemplateOverrides",
        },
        services: {
            $ref: "#/definitions/OrgConfigServicesDTO",
            title: "services",
        },
        tracker: {
            $ref: "#/definitions/TrackerDTO",
            title: "tracker",
        },
        webTheme: {
            title: "webTheme",
        },
    },
    propertyOrder: [
        "externalData",
        "services",
        "customAttributes",
        "customDataSchemas",
        "webTheme",
        "appTheme",
        "sendInBlueTemplateOverrides",
        "createUserPassOverride",
        "customLogo",
        "redirects",
        "allowedPaths",
        "portalUiPermissions",
        "disableShareEmail",
        "tracker",
        "removed",
    ],
    required: ["customAttributes", "customDataSchemas", "externalData", "services"],
    type: "object",
};
exports.isOrgConfigDTO = exports.ajv.compile(exports.OrgConfigDTOSchema);
function validate(value) {
    if (exports.isOrgConfigDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isOrgConfigDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "OrgConfigDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=OrgConfig.validator.js.map